import React from 'react';
import DashboardFrame from '../components/basic/DashboardFrame';
import strings from '../values/strings/strings';
import Updates from '../components/pagescomponents/Updates';

function Tools(props) {
    return (
        <>
            <DashboardFrame hideDrawer>
                <Updates />
            </DashboardFrame>
        </>
    );
}

export default Tools;